const PATH = 'fe.components.carousel';

const messages = {
  previousSlide: {
    key: `${PATH}.previous_slide`,
    defaultValue: 'Previous Slide'
  },
  nextSlide: {
    key: `${PATH}.next_slide`,
    defaultValue: 'Next Slide'
  },
  carouselText: {
    key: `${PATH}.carousel_text`,
    defaultValue: 'Carousel'
  },
  slide: {
    key: `${PATH}.slide`,
    defaultValue: 'slide'
  },
  slideIndex: {
    key: `${PATH}.slide_index`,
    defaultValue: '{{index}} of {{total}}'
  },
  visibleSlides: {
    key: `${PATH}.visible_slides`,
    defaultValue: 'Showing {{first}} to {{last}} of {{total}}'
  },
  goToPage: {
    key: `${PATH}.go_to_page`,
    defaultValue: 'Go to page {{index}} of {{total}}'
  },
  completedModal: {
    title: {
      key: `${PATH}.completed_modal.title`,
      defaultValue: `You already completed this {{name}} video this year`
    },
    viewScoreReport: {
      key: `${PATH}.completed_modal.view_score_report`,
      defaultValue: 'View Score Report'
    },
    retakeTest: {
      key: `${PATH}.completed_modal.retake_test`,
      defaultValue: 'Reset and Retake'
    }
  },
  videoTypes: {
    practice: {
      key: `${PATH}.video_types.practice`,
      defaultValue: 'practice'
    },
    training: {
      key: `${PATH}.video_types.training`,
      defaultValue: 'training'
    },
    calibration: {
      key: `${PATH}.video_types.calibration`,
      defaultValue: 'calibration'
    }
  }
};

export default messages;
